import type { ReactNode } from "react";
import { formatInstant, formatUtcInstant, type InstantStyle } from "../time";

/** An instant in the viewer's zone, labelled, with the exact UTC instant on hover.
 *  Renders `fallback` when there is no value. */
export default function Instant({
  iso,
  style = "compact",
  fallback = null,
}: {
  iso: string | null | undefined;
  style?: InstantStyle;
  fallback?: ReactNode;
}) {
  if (!iso) return <>{fallback}</>;
  return (
    <time dateTime={iso} title={formatUtcInstant(iso)}>
      {formatInstant(iso, { style })}
    </time>
  );
}
